import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CreaEquipoOncologia from "./CreaEquipos/CreaEquipoOncologia";
import DequipoOncologia from "../../EliminaEquipos/DequipoOncologia";

function EquipoConsultaExterna({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const fetchList = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOncologiaPorSolicitudId?SolicitudId=${idSolicitud}`,
    })
      .then((res) => setList(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (idSolicitud) {
      fetchList();
    }
  }, [idSolicitud]);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];
  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="container text-center">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2.2. EQUIPO PRIMARIO DE MEJORAMIENTO DE ONCOLOGÍA
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoOncologia
                idSolicitud={idSolicitud}
                onCreated={fetchList}
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6">No hay registros</td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.servicio}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>
                      {nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoOncologia
                            id={item.id}
                            onDelete={handleDelete}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoConsultaExterna;
